<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link :to="tramiteRoute">Trámites</router-link> >
            <router-link :to="tramiteFormRoute">Trámite {{ this.p_idTramite }}</router-link>
            > Solicitudes para modificación y carga de archivos
          </div>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;"
            @click="showModalHelp = true">
            help
          </span>
        </div>
      </div>
    </div>

    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Descripción</th>
          <th scope="col">Respuesta</th>
          <th scope="col">Estado</th>
          <th scope="col">Fecha Reg.</th>
          <th scope="col">Fecha Apr.</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="autorizacion in datosPaginados" :key="autorizacion.idAutorizacion">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(autorizacion.idAutorizacion)" title="Editar">edit_square</i></td>
          <td>{{autorizacion.descripcion}}</td>
          <td>{{autorizacion.observacion}}</td>
          <td>{{autorizacion.estadoAut}}</td>
          <td>{{getFormattedDate(autorizacion.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(autorizacion.fechaApr, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteAutorizacion(autorizacion.idAutorizacion)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPaginaTodos(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                  <textarea class="form-control"
                            id="descripcion"
                            name="descripcion"
                            v-model="datoAutorizacion.descripcion"
                            style='text-transform:uppercase'
                            :disabled="datoAutorizacion.estadoAut != null && datoAutorizacion.estadoAut !== 'ELABORACION'">
                  </textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Respuesta</label>
                </div>
                <div class="col-10">
                  <textarea class="form-control"
                            id="observacion"
                            name="observacion"
                            v-model="datoAutorizacion.observacion"
                            style="text-transform:uppercase;"
                            :disabled="datoAutorizacion.estadoAut == null || 
                                       idPerfil == 15  ||
                                       (idPerfil == 16 && datoAutorizacion.estadoAut !== 'ENVIADO')">
                  </textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="estadoAut" class="form-label">Estado</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="estadoAut" name="estadoAut" v-model="datoAutorizacion.estadoAut" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombreReg" class="form-label">nombreReg</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="nombreReg" name="nombreReg" v-model="datoAutorizacion.nombreReg" disabled>
                </div>
                <div class="col-2">
                  <label for="fechaReg" class="form-label">Fecha Reg.</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="fechaReg" name="fechaReg" :value="getFormattedDateTime(datoAutorizacion.fechaReg)" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <!-- <label for="nombreReg" class="form-label">nombreReg</label> -->
                </div>
                <div class="col-4">
                  <!-- <input type="text" class="form-control" id="nombreReg" name="nombreReg" v-model="datoAutorizacion.nombreReg" disabled> -->
                </div>
                <div class="col-2">
                  <label for="fechaEnv" class="form-label">Fecha Env.</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="fechaEnv" name="fechaEnv" :value="getFormattedDateTime(datoAutorizacion.fechaEnv)" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombreApr" class="form-label">nombreApr</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="nombreApr" name="nombreApr" v-model="datoAutorizacion.nombreApr" disabled>
                </div>
                <div class="col-2">
                  <label for="fechaApr" class="form-label">Fecha Apr.</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="fechaApr" name="fechaApr" :value="getFormattedDateTime(datoAutorizacion.fechaApr)" disabled>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                </div>
                <div class="col-4">
                </div>
                <div class="col-2">
                  <label for="fechaDesde" class="form-label">fecha Desde</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="fechaDesde" name="fechaDesde" :value="getFormattedDateTime(datoAutorizacion.fechaDesde)" disabled>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                </div>
                <div class="col-4">
                </div>
                <div class="col-2">
                  <label for="fechaHasta" class="form-label">fecha Hasta</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="fechaHasta" name="fechaHasta" :value="getFormattedDateTime(datoAutorizacion.fechaHasta)" disabled>
                </div>
              </div>
            </div>

          </div>
      </form>
      <div class="modal-footer">
        <button type="submit"
                class="btn btn-light"
                @click.prevent="guardarAutorizacion(1)"
                v-if="datoAutorizacion.estadoAut == null"
                title="Guardar">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;">save</span>
          Guardar
        </button>
        <button type="submit"
                class="btn btn-light"
                @click.prevent="guardarAutorizacion(2)"
                v-if="datoAutorizacion.estadoAut == null"
                title="Guardar y Enviar">
          <span class="material-symbols-outlined" style="font-size:32px;color:green; cursor: pointer;">send</span>
          Guardar y Enviar
        </button>
        <button type="submit"
                class="btn btn-light"
                @click.prevent="guardarEditAutorizacion(1)"
                v-if="datoAutorizacion.estadoAut=='ELABORACION'"
                title="Actualizar">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;">update</span>
          Actualizar
        </button>
        <button type="submit"
                class="btn btn-light"
                @click.prevent="guardarEditAutorizacion(2)"
                v-if="datoAutorizacion.estadoAut=='ELABORACION'"
                title="Actualizar y Enviar">
          <span class="material-symbols-outlined" style="font-size:32px;color:green; cursor: pointer;">send</span>
          Actualizar y Enviar
        </button>
        <button type="submit"
                class="btn btn-outline-success"
                @click.prevent="guardarEditAutorizacion(3)"
                v-if="idPerfil == 16 && datoAutorizacion.estadoAut != null && datoAutorizacion.estadoAut=='ENVIADO'"
                title="Actualizar">                
          <span class="material-symbols-outlined" style="font-size:32px;color:green; cursor: pointer;">check</span>
          Aceptar
        </button>
        <button type="submit"
                class="btn btn-outline-danger"
                @click.prevent="guardarEditAutorizacion(4)"
                v-if="idPerfil == 16 && datoAutorizacion.estadoAut != null && datoAutorizacion.estadoAut=='ENVIADO'"
                title="Actualizar">
          <span class="material-symbols-outlined" style="font-size:32px;color:red; cursor: pointer;">close</span>
          Rechazar
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js'
import dateFormat from '../../modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      autorizacions : [],
      datoAutorizacion : {},
      nombreBusqueda: '',
      titulo: '',
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      estiloImagen: {
        width: "200px",
        height: "200px"
      },
      idPerfil: 0,
    }
  },
  computed: {
    tramiteRoute() {
      if (this.idPerfil == 15) return '/tramite-carga';
      if (this.idPerfil == 16) return '/tramite';
      return '/'; // Ruta predeterminada
    },
    tramiteFormRoute() {
      if (this.idPerfil == 15) return '/tramiteform-carga/' + this.p_idTramite;
      if (this.idPerfil == 16) return '/tramiteform/' + this.p_idTramite;
      return '/'; // Ruta predeterminada
    }
  },
  mounted () {
    this.p_idTramite = this.$route.params.p_idtramite
    this.idPerfil = window.sessionStorage.getItem("idPerfil")
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    getFormattedDateTime(date) {
      return dateFormat.getFormattedDateTime(date);
    },
    totalPaginas(){
      return Math.ceil(this.autorizacions.length / this.elementosPorPagina)
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwautorizacions/idtramite/'+this.p_idTramite).then(response=>{
      this.autorizacions=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.autorizacions.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'descripcion'      
      ];
      const requiredFieldsText = [
        'descripcion'
      ];
      return validarForm(this.datoAutorizacion, requiredFields, requiredFieldsText);
    },
    async guardarAutorizacion(opcion){
      if(this.validarForm() === 1){
        try {
          if(opcion === 2){
            this.datoAutorizacion.estadoAut = "ENVIADO";
          }
          this.datoAutorizacion.idTramite = this.p_idTramite;
          this.datoAutorizacion.idUsuarioReg = window.sessionStorage.getItem("idUsuario");
          await api.post('/autorizacions', this.datoAutorizacion)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Autorizacion creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAutorizacion(opcion){
      if(this.validarForm() === 1){
        try {
          if(opcion === 2){
            this.datoAutorizacion.estadoAut = "ENVIADO";
          }
          if(opcion === 3){
            this.datoAutorizacion.estadoAut    = "APROBADA";
            this.datoAutorizacion.fechaApr     = new Date().toISOString();
            this.datoAutorizacion.idUsuarioApr = window.sessionStorage.getItem("idUsuario");
          }
          if(opcion === 4){
            this.datoAutorizacion.estadoAut = "RECHAZADA";
          }
          await api.post('/autorizacions', this.datoAutorizacion)
          $('#ventanaModal').modal('hide');
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "Autorizacion creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAutorizacion={}
      this.titulo   = 'Crear '
    },
    abrirModalEditar(idAutorizacion){
      this.modalWindow = true
      if(idAutorizacion != null){    
           api.get('/vwautorizacions/'+idAutorizacion).then(resp=>{
          this.datoAutorizacion = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
    },
    async deleteAutorizacion (idAutorizacion) {
      try{
        await api.delete('/autorizacions/'+idAutorizacion)
          this.getDataPaginaTodos(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
